import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getMemberships } from '../../../api/memberships';
import { UseMembershipFilter } from '../../../ts/interface/membership.interface';

const useMemberships = (
  filter?: UseMembershipFilter,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['memberships', filter?.pageNumber, filter?.limit, filter?.system_id, filter?.status],
    queryFn: () => getMemberships(filter),
    ...options,
  });
};

export default useMemberships;
